<template>
  <div class="c-echarts-pip role-level" v-loading="loading">
    <pie-echart v-if="ecData.length" :config-options="echartsOptions" />
    <no-data v-else />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import PieEchart from '@/components/echarts/echart-pie'
import { getRoleLevelDataEvaluatePip } from '@/api/ptom.data.model'
export default {
  name: 'PipEvaluate',
  components: { PieEchart },
  props: {
    detailTime: {
      type: Array,
      required: true
    },
    platform: {
      type: Number
    },
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    }
  },
  data() {
    const tipTitle = '等级'
    return {
      loading: null,
      ecData: [],
      echartsOptions: {
        title: {
          left: 'left',
          textStyle: { fontWeight: 'normal' }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // top: 'bottom',
          bottom: '1%'
        },
        series: [
          {
            name: tipTitle,
            type: 'pie',
            center: ['45%', '42%'],
            radius: '40%',
            label: {
              formatter: '{b}：{d}%'
              // formatter({ seriesName, percent, value, data }) {
              //   return `${seriesName}: ${percent}%`
              // }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    getData() {
      const [begTime, enTime] = this.detailTime || []
      this.ecData = []
      this.loading = true
      getRoleLevelDataEvaluatePip({
        begTime,
        enTime,
        platform: this.platform,
        gameId: this.productId,
        chlId: this.chlUserId,
        sourceId: this.sourceId
      }).then((data) => {
        if (typeof data !== 'symbol') {
          this.loading = false
          if (data && isArray(data.list)) {
            this.ecData = data.list.map((ret) => {
              return {
                ...ret,
                value: ret.y
              }
            })

            const dataSeries = this.echartsOptions.series.pop()
            this.$set(this.echartsOptions, 'series', [Object.assign(dataSeries, { data: this.ecData })])
          }
        }
      })
    }
  },
  created() {
    this.getData()
  },
  watch: {
    detailTime() {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-echarts-pip {
  width: 50%;
  height: 100%;
}
</style>
